// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.select-item[data-v-128e78c4]{\n  width: 100%;\n}\n.tip[data-v-128e78c4]{\n  font-size: 14px;\n  font-weight: 400;\n  color: #303133;\n}\n.dialog-footer[data-v-128e78c4]{\n  margin-top: -16px;\n  text-align: center;\n}\n.btn-submit[data-v-128e78c4]{\n  width: 500px;\n  height: 40px;\n  border-radius: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
